import React from 'react';
import { FormGroup } from 'reactstrap';
import _ from 'lodash';

import C from '../C';
import DataStore, { getPath } from '../base/plumbing/DataStore';
import ActionMan from '../plumbing/ActionMan';
import Misc from '../base/components/Misc';
import PropControl from '../base/components/PropControl';
import CardAccordion, { Card } from '../base/components/CardAccordion';
import CharityControls from './CharityControls';
import { BannerControls, OnXControls } from './CommonControls';
import BrandingEditor from './BrandingEditor';
import ShareWidget, {ShareLink} from '../base/components/ShareWidget';
import {PartnerControlSummary} from './SnogMarryAvoidPage';
import Publisher from '../data/Publisher';
import VariantControls from './VariantControls';
import ListItems from './ListItems';
import { setWindowTitle } from '../base/plumbing/Crud';
import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc';


function PublisherPage() {
	const type = C.TYPES.Publisher;
	setWindowTitle(type);

	const blocked = Misc.CheckAccess({can: 'editSite'});
	if (blocked) return blocked;

	const path = DataStore.getValue(['location','path']);
	const publisherId = path[1];
	// list?
	if ( ! publisherId) {
		return (<div>
			<h1>Publishers</h1>
			<p>Publishers are automatically created when they add our tag to their page.</p>
			<p>You can also seed the system for a prospective publisher by calling as.good-loop.com?site=theirdomain.com,
			though beware that their actual url may not always be what you think.</p>
			<ListItems type={type} />
		</div>);
	}

	let pvPublisher = ActionMan.getDataItem({type:C.TYPES.Publisher, id:publisherId, status:C.KStatus.DRAFT});
	let pub = pvPublisher.value;
    const item = pub;
    console.log("PUBLISHER", pub, "pvPUBLISHER", pvPublisher);
	setWindowTitle(item);	
	return (
		<div>
			<h1>Edit Publisher: {(pub && Publisher.getName(pub)) || publisherId}</h1>
			{pub? <div>
				<a href={'#pubdash/'+escape(pub.id)}>Publisher Dashboard</a>
				<EditPublisherForm publisher={pub} />
				<ShareWidget item={pub} hasButton />
			</div>
				: <Misc.Loading />}
		</div>
	);
} // ./PublisherPage


function EditPublisherForm({publisher}) {
	const pub = publisher;
	const type = C.TYPES.Publisher;
	let path = getPath(C.KStatus.DRAFT, type, publisher.id);
	return (
		<div>
			<CardAccordion>
				
				<Card title="Basic Setup">
					ID <a href={pub.id} target="_blank">{pub.id}</a> <br />
					<PropControl label="name" item={pub} path={path} prop="name" /> <br />
					<PropControl label="Website" type="url" item={pub} path={path} prop="url" /> <br />
					<PropControl label="Owner" item={pub} path={path} prop="owner" /> <br />
					<PropControl label="Keywords" item={pub} path={path} prop="keywords" /> <br />
				</Card>

				<CharityControls entity={pub} />

				<BrandingEditor entity={pub} path={path} />

				<VariantControls path={path} entity={pub} />

				<BannerControls entity={pub} />

				<Card title="Backfill and Waterfall">
					<FormGroup>
						<h4>Optional Backfill</h4>
						<p><small>
							If we don't have an advert, then the backfill code will be inserted. This lets
							bloggers setup a waterfall of ad-providers. E.g. Good-Loop (high-value, high-quality) can pass control to AdSense (more coverage).
						</small></p>
						<PropControl type="textarea" item={pub} prop="backfill" path={path} /> <br/>
					</FormGroup>

					<FormGroup>
						Backfill trigger price (backfill if we can't beat this value) - 0 is the default for backfill when we have no advert, -1 will switch backfill off.
						<PropControl type="Money" item={pub} prop="backfillPrice" path={path} /> <br/>
					</FormGroup>
				</Card>

				<PaymentDetails pub={pub} path={path} />

				<Card title="Partner Control (whose adverts)">
					<PartnerControlSummary item={pub} />
				</Card>

				<Card title="Advanced">

					<PropControl label="Publishers own page for more-info" type="url" item={pub} prop="moreInfo" path={path} /> <br/>

					Default Slot Formats
					<SlotFormats pub={pub} path={path} />

					<p>Shadows some Advert settings. <small>@DW TODO would it make sense to use an Advert object as the data storage for these??</small></p>
					on render
					
					<OnXControls path={path} />
					
					<PropControl label="Block repeated showing to the same person" type="checkbox" prop="noRepeat" path={path} item={pub} />
					<p><small>The default behaviour is to allow repeated showing, but treat it as increasingly less valuable (i.e. lower the bid price).</small></p>
					<PropControl label="Custom CSS" type="code" lang="css" prop="customcss" path={path.concat('advanced')}
						help="Extra CSS rules, specific to this publisher (generally for the banner), which will be appended to the DOM." />
				</Card>
			</CardAccordion>
			<SavePublishDeleteEtc type={C.TYPES.Publisher} id={publisher.id} sendDiff />
		</div>
	);
}


function SlotFormats({pub, path}) {
	let slot = pub.slot || {};
	let formats = ['leaderboard', 'mediumrectangle', 'billboard', 'vbnr', 'stickyfooter', 'mpu2'];
	let slotpath = _.concat(path, 'slot');
	let controls = formats.map(f =>
		(<tr key={f}>
			<th>{f}</th>
			<SlotFormat path={slotpath} pub={pub} format={f} slot={slot}/>
			<SlotFormat isMobile path={slotpath} pub={pub} format={f} slot={slot}/>
		</tr>));
	return (<div><table className="table"><tbody>
		<tr><th>Format</th><th>Desktop</th><th>Mobile</th></tr>
		{controls}</tbody>
	</table></div>);
}

function SlotFormat({pub, format, slot, path, isMobile}) {
	let fpath = _.concat(path, isMobile ? 'mobileFormats' : 'desktopFormats');
	let item = isMobile? slot.mobileFormats : slot.desktopFormats;
	// console.log('SlotFormat', pub, format, slot, fpath, isMobile, 'item', item);
	return (
		<td>
			<PropControl dflt={true} prop={format} path={fpath} item={item} type="checkbox" />
		</td>
	);
}


function PaymentDetails({path, pub, ...stuff}) {
	let bank = (pub.payment || {}).bank;
	let bpath = path.concat(['payment', 'bank']);
	return (
		<Card title="Payment Details" {...stuff} >
			<PropControl item={pub} path={path.concat('payment')}
				prop="revenueModel" label="Revenue model" type="select" options={['revshare', 'buybanner', 'free']}
			/>
			<PropControl item={pub} path={path} prop="via" label="Via" help="Use this for publishers provided via an Agency. It can also be set in the tag with the parameter gl.via" />

			<p>Please provide your bank details so we can pay your earnings to you.</p>
			<PropControl item={bank} path={bpath} prop="accountNumber" label="Bank account number" />
			<PropControl item={bank} path={bpath} prop="sortCode" label="Sort code" />
		</Card>
	);
}

export default PublisherPage;
